import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { getDate } from "../../../../shared/getDate";

export default function VideoItem({ video, handleVideoClick }) {
  const [duration, setDuration] = useState(null);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        transition: "0.5s all",
      }}
      onClick={() => handleVideoClick(video?.postId)}
    >
      <Box
        sx={{
          height: "470px",
          borderRadius: "16px",
          overflow: "hidden",
        }}
      >
        <video
          src={video?.media}
          poster={video?.poster}
          onLoadedMetadata={(e) => setDuration(e?.target?.duration)}
          preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
          alt=""
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "1em",
          color: "text.secondary",
          pointerEvents: "none",
          mt: 2,
          mb: 1,
        }}
      >
        {video?.releaseDate && (
          <>
            <Typography variant="subtitle2">
              {getDate(video?.releaseDate, undefined, "DD MMM, YYYY")}
            </Typography>
            <Box
              sx={{
                backgroundColor: "text.secondary",
                width: "1px",
                height: "20px",
              }}
            />
          </>
        )}
        {duration && (
          <>
            <Typography variant="subtitle2">
              {duration < 60
                ? `${Math.ceil(duration)} sec`
                : `${Math.ceil(duration / 60)} min`}
            </Typography>
            <Box
              sx={{
                backgroundColor: "text.secondary",
                width: "1px",
                height: "20px",
              }}
            />
          </>
        )}
        <Typography variant="subtitle2">Documentary</Typography>
      </Box>

      <Typography variant="h6" fontWeight="bold">
        {video?.name}
      </Typography>

      <Typography variant="subtitle2" color="text.secondary">
        {video?.description}
      </Typography>
    </Box>
  );
}
